import {
  GET,
  POST
} from "@/axios/axios"

export const services = {
  ServicerImform: (param) => { // 服务商信息
    return GET("/backend/custom/queryServiceByPage", param);
  },
  ServicerInsert: (param) => { // 服务商信息新增
    return POST("/backend/custom/saveService", param);
  },
  ServicerRemove: (param) => { // 服务商信息删除
    return GET("/backend/custom/delete", param);
  },
  ServiceResume: (param) => { // 服务商启用
    return GET("/backend/custom/enableCustom", param)
  },
  ModifyAccount: (param) => { // 修改账号
    return POST("/backend/user/updateAccount", param);
  },
  ExamineTaxRules: (param) => { // 个税规则查看
    return GET("/backend/customRules/queryServiceRules", param);
  },
  AgentDefaultPw: (param) => { // 获取初始密码；
    return GET("/backend/user/getDefaultPassword", param);
  },
  SaveTaxRules: (param) => { // 个税规则保存
    return POST("/backend/customRules/saveServiceRules", param);
  },
  RemoveTaxRules: (param) => { // 个税规则删除
    return GET("/backend/customRules/delete", param);
  },
  RditSettle: (param) => {
    return POST("/backend/customRules/updateAgentSettle", param);
  },
  saveAccount: (param) => { // 添加私户
    return POST("/backend/user/dls/saveAccount", param);
  },
  saveAliAccount: (param) => { // 添加支付宝
    return POST("/backend/user/dls/saveAliAccount", param);
  },
  ServiceBalanceQuery: (param) => { // 服务商查询余额
    return GET("/backend/customPaymentSetting/serviceBalanceQuery", param);
  },
  callBackInfoList: (param) => { // API设置列表
    return GET("/backend/apiSetting/callBackInfoList", param);
  },
  updateCallBackInfo: (param) => { // 新增通知配置
    return POST("/backend/apiSetting/updateCallBackInfo", param);
  },
  updateApiCallBack: (param) => { // 编辑通知配置
    return POST("/backend/apiSetting/updateApiCallBack", param);
  },
  deleteApiCallBack: (param) => { // 删除通知配置
    return POST("/backend/apiSetting/deleteApiCallBack", param);
  },
  queryService: (param) => { // 获取商户的服务商
    return GET("/backend/account/queryServiceForMerchant", param);
  },
  accountForMerchant: (param) => { // 获取账户列表
    return GET("/backend/account/queryAccountForMerchant", param);
  },
  queryPremiumInfo: (param) => { // 获取手续费信息
    return GET("/backend/custom/queryPremiumInfo", param);
  },
  updatePremiumInfo: (param) => { // 修改手续费信息接口
    return POST("/backend/custom/updatePremiumInfo", param);
  },
  categoryList: (param) => { // 服务商绑定开票类目列表
    return GET("/backend/serviceMerchantRel/serviceBindInvoicingCategoryList", param);
  },
  putInvoCategoryId: (param) => { // 服务商绑定开票类目列表
    return POST("/backend/serviceMerchantRel/putInvoicingCategoryById", param);
  },
  putInvoCategory: (param) => { // 批量更新服务商关联的开票类目
    return POST("/backend/serviceMerchantRel/putInvoicingCategory", param);
  },
  sendMerchantInfo: (param) => { // 发送商户信息回调接口
    return GET("/backend/custom/sendMerchantInfo", param);
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/serviceprovider.js